import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import tools from '../tools';
import styles from '../styles.module.css';
import classNames from 'classnames';
import ToolbarHDivider from './ToolbarHDivider';
import WhiteboardController from '../controllers/WhiteboardController';

const ZoomToolbar: React.FC = () => {
  const controller = useController(WhiteboardController);
  const { hasActiveObjectTransformation } = controller.state;
  const toolButtons = [
    tools.ToolPan,
    tools.ToolZoomOut,
    tools.ToolZoomLevel,
    tools.ToolZoomIn,
  ];
  const DebugButton = controller.props.debug?.DebugButton;

  return (
    <div
      className={classNames(styles.zoomToolbar, styles.toolbarCommon, {
        [styles.toolbarFade]: hasActiveObjectTransformation,
      })}
    >
      {DebugButton && (
        <>
          <DebugButton />
          <ToolbarHDivider />
        </>
      )}
      {toolButtons.map(tool => {
        const ButtonComponent = tool.buttonComponent();
        return <ButtonComponent key={tool.toolName} />;
      })}
    </div>
  );
};

export default ApplicationView(ZoomToolbar);
